export default "__VITE_ASSET__B9Dby9Ru__"